// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"LvXbh5M8WjnW60v_TXq4M"};